import objectHash from 'object-hash';
import { Fragment, useContext, useRef } from 'react';

import {
  type ContentfulData,
  generateSectionKey,
} from '@/integrations/contentful';
import { DraftModeContext } from '@/providers/DraftModeProvider/DraftModeContext';

import {
  type AllTheStrapsSectionOpts,
  renderContentfulAllTheStrapsSection,
} from './cms';

export const usePreRenderCmsSections = (
  allTheStrapsCmsData: ContentfulData[],
) => {
  const draftMode = useContext(DraftModeContext);
  const cmsContentMap = useRef(new Map());
  const hashMap = useRef(new Map());

  const sectionsOpts: AllTheStrapsSectionOpts = [
    {
      type: 'Placeholder',
      opts: {
        type: 'product listing',
      },
    },
    {
      type: 'HeroProductListing',
      opts: {
        type: 'all the straps',
      },
    },
  ];

  const buildCms = (data: ContentfulData, i: number) => {
    let hash = hashMap.current.get(data);

    if (!hash) {
      hash = objectHash(data);
      hashMap.current.set(data, hash);
    }

    let el = cmsContentMap.current.get(hash);

    if (el) {
      return el;
    }

    el = (
      <Fragment key={generateSectionKey(data, i)}>
        {renderContentfulAllTheStrapsSection(
          data,
          sectionsOpts,
          undefined,
          draftMode,
        )}
      </Fragment>
    );

    cmsContentMap.current.set(hash, el);
    return el;
  };

  const cmsSectionAll = allTheStrapsCmsData.map(buildCms);

  return { cmsSectionAll };
};
